module.exports = __webpack_public_path__ + "static/21-43e1434a1bf5afdf4250f821e7c98514.jpg";